import type { Notification } from '@/services/http/notificationsService/getUserNotifications'

const inviteNotificationTypes: Notification['type'][] = [
  'INVITATION',
  'PORTFOLIO_INVITE',
]

function getNotificationActionLabel(type: Notification['type']) {
  if (type === 'SYSTEM') return null

  if (inviteNotificationTypes.includes(type)) {
    return 'Clique aqui para aceitar o convite.'
  }

  return 'Clique para acessar'
}

export { getNotificationActionLabel }
